export const STYLE_FACET = 'style';
export const COLOR_FACET = 'color';

// `size` sits 4th so it lands inline ahead of the "More" pill at the breakpoints that show pills —
// card dimensions are a primary buying decision on print categories.
// `product` (currently only `product:magnet`) has a single option, so the pill never renders
// (`useResponsiveFilterOverflow` hides facets with <2 options); it exists for nav deep links.
export const FACET_ORDER = [STYLE_FACET, COLOR_FACET, 'price', 'size', 'photo', 'foil', 'orientation', 'format', 'product'] as const;
